import {
  IntegrationLaunchSource,
  useIntegrationEhrInfo,
} from '@/hooks/integrations/useIntegrationEhrInfo';

// Uses integrationLaunchSource (not deprecated integrationConnectionType) to cover all four integration types.
export const useHasActiveEhrIntegration = (): {
  hasActiveIntegration: boolean;
  isPending: boolean;
} => {
  const { integrationLaunchSource, isPending } = useIntegrationEhrInfo();

  return {
    hasActiveIntegration: integrationLaunchSource !== IntegrationLaunchSource.NONE,
    isPending,
  };
};
